<template>
    <div v-if="isAmbalagi && !mixinIsWelfare()" class="paymentsList">
        <div class="vivamod_loyalty">
            <!--<a class="link" :href="businessVivamodHost" target="_blank">-->
            <a class="link" :href="businessVivamodHost" target="_blank">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path custom-fill-primary fill-rule="evenodd" clip-rule="evenodd" d="M10.8205 0L11.8513 1.03076C11.4247 1.45729 11.4247 2.14785 11.8513 2.57437C12.2778 3.0009 12.9683 3.0009 13.3949 2.57437L14.4256 3.60514C13.9991 4.03166 13.9991 4.7273 14.4256 5.15382C14.8522 5.58035 15.5427 5.58035 15.9743 5.15382L17 6.18459L14.9232 8.26135L8.74373 2.07676L10.8205 0V0ZM14.3038 8.88082L6.18459 17L5.15382 15.9743C5.58035 15.5427 5.58035 14.8522 5.15382 14.4256C4.7273 13.9991 4.03166 13.9991 3.60514 14.4256L2.57437 13.3949C3.0009 12.9683 3.0009 12.2778 2.57437 11.8513C2.14785 11.4247 1.45729 11.4247 1.03076 11.8513L0 10.8205L8.12425 2.69624L14.3038 8.88082Z" fill="#0071BC" />
                </svg>
                <span>Vivamod per il loyalty ed il marketing. Scopri...</span>
            </a>
        </div>
        <div class="logos">
            <span class="mr-2">Paghi con:</span>
            <span class="logo">
                <img src="assets/pagamenti/visa.svg" />
            </span>
            <span class="logo">
                <img src="assets/pagamenti/mastercard.svg" />
            </span>
            <span class="logo">
                <img src="assets/pagamenti/american-express.svg" />
            </span>
            <span class="logo">
                <SvgLogoDiscountCode class="logo" />
            </span>
            <span class="logo" v-if="config.guiSettings.integrations.etc.enabled">
                <img src="assets/pagamenti/etc.svg" />
            </span>
            <span class="logo" v-if="config.guiSettings.integrations.promoshopping.enabled">
                <img src="assets/pagamenti/promoshopping.svg" />
            </span>
            <span class="logo" v-if="config.guiSettings.integrations.scalapay.enabled">
                <img src="assets/pagamenti/scalapay.svg" />
            </span>
            <a class="logo ml-3" @click="mixinGoTo('sistemi-di-pagamento',{})">Scopri di più</a>
        </div>
        <!-- amex | mastecard | visa | promoshopping | scalapay | ticket compliments -->

        <!--<div class="vivamod_adv">
            <img src="assets/logo-agenzia-vivamod.svg" />
            <router-link :to="{name: 'adv'}">
                <strong>Sei utente welfare aziendale?</strong><br/>
                <span>Scopri come utilizzare il tuo credito con Agenzia viaggi by Vivamod</span>
            </router-link>
        </div>-->
    </div>
</template>

<script>

import Vue from "vue"

export default {
  name: 'payments-list',
  components: {
    SvgLogoDiscountCode: () => import('@/components/' + process.env.VUE_APP_CUSTOM_SRC + 'svg/logoDiscountCode')
      .then(function(SvgLogoDiscountCode) {
        window.console.log('async: SvgLogoDiscountCode Component loaded')
        return SvgLogoDiscountCode
      }),
  },
  data(){
    return {
      config: Vue.prototype.$config,
      isAmbalagi: process.env.VUE_APP_NAME == 'ambalagi',
      businessVivamodHost: process.env.VUE_APP_BUSINESS_VIVAMOD_HOST,
    }
  }
}
</script>

<style lang="scss">
    
    
    
    

    .paymentsList
    {
        padding-top: 20px;
        display:flex;
        flex-wrap:wrap;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        color:$black;
        @include customize-color(text);

        & > div {
            padding-right: 20px;
            margin-right: 20px;

            margin-top: 15px;
            margin-bottom: 15px;

            @include media-breakpoint-up(xxl){
                border-right: 1px solid $gray-500;
            }

            &:last-child {
                border-right: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }

        .vivamod_adv {
            display: flex;
            align-items: center;

            a {
                color: $tertiary;
            }

            img {
                width: 40px;
                margin-right: 10px;
            }

            span {
                font-size: 11px; 
                display: block;
            }
        }

        .link
        {
            @include customize-color(cta);
            display: block;
            span
            {
                text-decoration: underline;
            }
            svg
            {
                width: 26px;
                height: auto;
                margin-right: 10px;
            }
        }

        .logos
        {
            display:flex;
            align-items: center;
            flex-wrap:wrap;
            justify-content: center;
            max-width: 500px;

            .mr-2
            {
                min-width: 100%;
                text-align: center;
            }
            @include media-breakpoint-up(lg)
            {
                //justify-content: flex-start;
                .mr-2
                {
                    min-width: auto;
                    text-align: right;
                    padding-bottom:0;
                }
            }
            @include media-breakpoint-up(xl)
            {
                max-width: 100%;
            }
        }

        .logo
        {
            @extend .custom-color-cta !optional;
            text-decoration: underline;
            &:hover
            {
                text-decoration: underline;
            }
            img,svg
            {
                height:18px;
                width:auto;
                margin:8px;
            }
        }
    }
</style>